(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-story-section"] && !Shopify.designMode) return;
  try {
    
  // 滾動觸發動畫
  const observerOptions = {
    threshold: 0.2,
    rootMargin: '0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, observerOptions);

  // 監聽所有需要動畫的元素
  document.addEventListener('DOMContentLoaded', () => {
    const animatedElements = document.querySelectorAll('.timeline-item, .story-header');
    animatedElements.forEach(el => {
      observer.observe(el);
    });
  });

  // 視差滾動效果
  window.addEventListener('scroll', () => {
    const scrolled = window.pageYOffset;
    const section = document.querySelector('.brand-story-section');
    
    if (section) {
      const rect = section.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        const parallaxSpeed = 0.3;
        const yPos = -(scrolled * parallaxSpeed);
        section.style.backgroundPosition = `center ${yPos}px`;
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-coupon"] && !Shopify.designMode) return;
  try {
    
(function () {
  var CART_UPDATE_URL = (window.Theme && Theme.routes && Theme.routes.cart_update_url)
    || '/cart/update.js';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root)
    ? Shopify.routes.root.replace(/\/$/, '') : '';
  var KNOWN_CART_SECTION_IDS = [
    'template--20474166837499__cart-section',
    'template--20474166837499__cart_coupon_a3tRCK',
    'template--20474166837499__cart_totals_Cya3eE'
  ];
  var globalSyncLockUntil = 0;

  /* ==============================================
     通知主題的原生購物車元件刷新
     - discount:update → cart-items-component 刷新商品列表
     - cart:update     → cart-totals 等其他區塊
     ============================================== */
  function sectionIdFromElement(el) {
    if (!el) return '';
    var sid = el.dataset && el.dataset.sectionId;
    if (sid) return sid;

    var section = el.closest && el.closest('.shopify-section[id^="shopify-section-"]');
    if (!section || !section.id) return '';
    return section.id.replace(/^shopify-section-/, '');
  }

  function collectCartSectionIds(ownSectionId) {
    var ids = {};
    if (ownSectionId) ids[ownSectionId] = true;
    for (var k0 = 0; k0 < KNOWN_CART_SECTION_IDS.length; k0++) {
      ids[KNOWN_CART_SECTION_IDS[k0]] = true;
    }

    var directNodes = document.querySelectorAll(
      '[data-section-id][data-section-type="cart-totals"], [data-section-id][data-section-type="main-cart"], [data-section-id][data-section-type="cart-coupon"]'
    );
    for (var i = 0; i < directNodes.length; i++) {
      var directId = sectionIdFromElement(directNodes[i]);
      if (directId) ids[directId] = true;
    }

    /* 直接從 cart-items-component 反推其所屬 section（最準） */
    var cartItemNodes = document.querySelectorAll('cart-items-component, .cart-items-component');
    for (var j = 0; j < cartItemNodes.length; j++) {
      var cartId = sectionIdFromElement(cartItemNodes[j]);
      if (cartId) ids[cartId] = true;
    }

    /* 再補抓主要購物車區塊容器 */
    var cartContainers = document.querySelectorAll('.cart-page, .cart-items, .cart-page__items');
    for (var k = 0; k < cartContainers.length; k++) {
      var containerId = sectionIdFromElement(cartContainers[k]);
      if (containerId) ids[containerId] = true;
    }

    return Object.keys(ids);
  }

  function notifyCartUpdate(cartData) {
    var sections = (cartData && cartData.sections) ? cartData.sections : {};
    var payload = {
      resource: cartData || {},
      data: { sections: sections }
    };

    /* 用 CustomEvent 補齊 detail，避免 cart 元件讀取 event.detail 時報錯 */
    document.dispatchEvent(new CustomEvent('discount:update', {
      bubbles: true,
      detail: payload
    }));

    /* 同時也觸發通用的 cart 事件，給 cart-totals 和其他自訂監聽器 */
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: payload
    }));
    document.dispatchEvent(new CustomEvent('cart:updated', {
      bubbles: true,
      detail: payload
    }));
  }

  function hardRefreshSection(sectionId) {
    if (!sectionId) return Promise.resolve();
    var url = ROOT + '/cart?section_id=' + encodeURIComponent(sectionId);
    return fetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var targetId = 'shopify-section-' + sectionId;
        var current = document.getElementById(targetId);
        var fresh = doc.getElementById(targetId);
        if (current && fresh) current.replaceWith(fresh);
      })
      .catch(function () {});
  }

  function hardRefreshCartSections(ids, currentSid) {
    if (Date.now() < globalSyncLockUntil) return;
    if (!ids || !ids.length) return;
    var targets = ids.filter(function (id) { return id && id !== currentSid; });
    if (!targets.length) return;
    Promise.all(targets.map(hardRefreshSection)).then(function () {
      document.querySelectorAll('[data-section-type="cart-coupon"]').forEach(function (el) {
        el.__couponInit = false;
        initCoupon(el);
      });
    });
  }

  /* ==============================================
     讀取目前已套用的折扣碼（從 pill DOM 取得）
     ============================================== */
  function getExistingCodes(wrapper) {
    var pills = wrapper.querySelectorAll('.cart-coupon__pill-remove');
    var codes = [];
    for (var i = 0; i < pills.length; i++) {
      var c = pills[i].dataset.discountCode;
      if (c) codes.push(c);
    }
    return codes;
  }

  function applyPillStates(wrapper, discountCodes) {
    var codes = Array.isArray(discountCodes) ? discountCodes : [];
    var applicableMap = {};
    for (var i = 0; i < codes.length; i++) {
      var code = String(codes[i].code || '').toUpperCase();
      if (!code) continue;
      applicableMap[code] = (codes[i].applicable !== false);
    }

    var buttons = wrapper.querySelectorAll('.cart-coupon__pill-remove');
    for (var j = 0; j < buttons.length; j++) {
      var btn = buttons[j];
      var codeUpper = String(btn.dataset.discountCode || '').toUpperCase();
      var pill = btn.closest('.cart-coupon__pill');
      if (!pill) continue;

      var amountEl = pill.querySelector('.cart-coupon__pill-amount');
      pill.classList.remove('cart-coupon__pill--pending');
      pill.classList.remove('cart-coupon__pill--active');
      pill.classList.remove('cart-coupon__pill--invalid');

      if (Object.prototype.hasOwnProperty.call(applicableMap, codeUpper)) {
        if (amountEl) amountEl.textContent = '已套用';
      }
    }
  }

  /* ==============================================
     initCoupon
     ============================================== */
  function initCoupon(wrapper) {
    var sid = wrapper.dataset.sectionId;
    if (wrapper.__couponInit) return;
    wrapper.__couponInit = true;

    var trigger     = wrapper.querySelector('.cart-coupon__trigger');
    var form        = wrapper.querySelector('.cart-coupon__form');
    var input       = wrapper.querySelector('.cart-coupon__input');
    var submitBtn   = wrapper.querySelector('.cart-coupon__submit');
    var errorEl     = wrapper.querySelector('.cart-coupon__error');
    var errorText   = wrapper.querySelector('.cart-coupon__error-text');
    var successEl   = wrapper.querySelector('.cart-coupon__success');
    var successText = wrapper.querySelector('.cart-coupon__success-text');
    var messageTimer = null;

    /* ---------- 展開 / 收合 ---------- */
    trigger.addEventListener('click', function () {
      var isOpen = wrapper.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', isOpen);
    });

    function hideMessages() {
      if (messageTimer) {
        clearTimeout(messageTimer);
        messageTimer = null;
      }
      errorEl.classList.add('hidden');
      successEl.classList.add('hidden');
    }
    function scheduleHideMessages() {
      if (messageTimer) clearTimeout(messageTimer);
      messageTimer = setTimeout(function () {
        errorEl.classList.add('hidden');
        successEl.classList.add('hidden');
        messageTimer = null;
      }, 4000);
    }
    function showError(msg) {
      hideMessages();
      errorText.textContent = msg;
      errorEl.classList.remove('hidden');
      scheduleHideMessages();
    }
    function showSuccess(msg) {
      hideMessages();
      successText.textContent = msg;
      successEl.classList.remove('hidden');
      scheduleHideMessages();
    }
    function setLoading(on) {
      submitBtn.disabled = on;
      submitBtn.textContent = on ? '驗證中…' : '套用';
    }

    function updateDiscountCodes(codes, sectionIds) {
      return fetch(CART_UPDATE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          discount: codes.join(','),
          sections: sectionIds
        })
      }).then(function (r) { return r.json(); });
    }

    function applyDiscountCodes(codes, sectionIds) {
      var normalized = (codes || []).filter(Boolean);
      var sidList = Array.isArray(sectionIds) && sectionIds.length ? sectionIds : collectCartSectionIds(sid);
      return updateDiscountCodes(normalized, sidList);
    }

    function fetchCartState(sectionIds) {
      var sectionsUrl = ROOT + '/cart?sections=' + encodeURIComponent(sectionIds.join(','));
      return Promise.all([
        fetch(ROOT + '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }),
        fetch(sectionsUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.json(); })
          .catch(function () { return {}; })
      ]).then(function (result) {
        var cart = result[0] || {};
        var sections = result[1] || {};
        cart.sections = sections;
        return cart;
      });
    }

    function findDiscountMatch(data, code) {
      var target = String(code || '').toUpperCase();
      var discountCodes = (data && data.discount_codes) ? data.discount_codes : [];
      for (var i = 0; i < discountCodes.length; i++) {
        if (String(discountCodes[i].code || '').toUpperCase() === target) {
          return discountCodes[i];
        }
      }
      return null;
    }

    function getEffectiveDiscountAmount(data, match) {
      if (!match || match.applicable === false) return 0;
      /* 商品折扣常在 match.amount 為 0，改以整體購物車實際折扣比較最準 */
      var totalDiscount = Number(data && data.total_discount);
      if (!isNaN(totalDiscount) && totalDiscount > 0) return totalDiscount;

      var amount = Number(match.amount || 0);
      return isNaN(amount) ? 0 : amount;
    }

    function evaluateSingleCode(code, sectionIds) {
      return applyDiscountCodes([code], sectionIds)
        .then(function (data) {
          if (data && data.discount_codes) return data;
          return fetchCartState(sectionIds);
        })
        .then(function (data) {
          var match = findDiscountMatch(data, code);
          return {
            code: code,
            match: match,
            amount: getEffectiveDiscountAmount(data, match),
            data: data
          };
        });
    }

    /* ==============================================
       套用折扣碼
       用 /cart/update.js + discount 參數（跟主題原生 cart-discount.js 一致）
       支援多碼：保留已有碼 + 加新碼，逗號分隔
       ============================================== */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = input.value.trim();
      if (!code) return;

      /* 檢查是否已套用 */
      var existing = getExistingCodes(wrapper);
      if (existing.indexOf(code) !== -1) {
        showError('優惠碼「' + code.toUpperCase() + '」已經套用過了');
        return;
      }

      hideMessages();
      setLoading(true);

      var sectionIds = collectCartSectionIds(sid);
      /* 先嘗試保留既有碼 + 新碼 */
      var firstAttemptCodes = existing.concat([code]);

      applyDiscountCodes(firstAttemptCodes, sectionIds)
      .then(function (data) {
        if (data && data.discount_codes) return data;
        return fetchCartState(sectionIds);
      })
      .then(function (data) {
        setLoading(false);
        var upper = code.toUpperCase();
        var match = findDiscountMatch(data, upper);

        if (match) {
          if (match.applicable === false) {
            /* 互斥 / 不適用：
               - 若目前已經有多張碼，避免誤刪原本可並行折扣，直接回復原狀
               - 只有「0~1 張既有碼」時才做單碼比價 */
            if (existing.length > 1) {
              return applyDiscountCodes(existing, sectionIds)
                .then(function (rollbackData) {
                  var rollbackPayload = rollbackData && rollbackData.discount_codes ? rollbackData : data;
                  showError('新優惠碼目前無法與既有優惠同時使用，已保留原本已套用的優惠');
                  input.value = '';

                  var rollbackHtml = rollbackPayload.sections && rollbackPayload.sections[sid];
                  if (rollbackHtml) {
                    refreshSelfFromHtml(rollbackHtml);
                  } else {
                    refreshSection(sid);
                  }
                  applyPillStates(wrapper, rollbackPayload.discount_codes);

                  wrapper.__skipMonitorUntil = Date.now() + 3000;
                  notifyCartUpdate(rollbackPayload);
                  hardRefreshCartSections(sectionIds, sid);
                });
            }

            /* 既有碼 <= 1：可嘗試單碼比價，保留折扣金額最高者 */
            var candidates = existing.concat([code])
              .filter(Boolean)
              .filter(function (v, idx, arr) { return arr.indexOf(v) === idx; });

            return Promise.all(candidates.map(function (candidate) {
              return evaluateSingleCode(candidate, sectionIds);
            }))
              .then(function (results) {
                var best = null;
                for (var i = 0; i < results.length; i++) {
                  if (!best || results[i].amount > best.amount) best = results[i];
                }

                if (!best || !best.match || best.match.applicable === false) {
                  showError('優惠碼目前無法使用，可能已用完、過期、未符合條件或與其他優惠衝突');
                  input.value = '';
                  if (data.sections && data.sections[sid]) {
                    refreshSelfFromHtml(data.sections[sid]);
                  } else {
                    refreshSection(sid);
                  }
                  applyPillStates(wrapper, data.discount_codes);
                  wrapper.__skipMonitorUntil = Date.now() + 3000;
                  notifyCartUpdate(data);
                  hardRefreshCartSections(sectionIds, sid);
                  return;
                }

                return applyDiscountCodes([best.code], sectionIds)
                  .then(function (bestData) {
                    if (bestData && bestData.discount_codes) return bestData;
                    return fetchCartState(sectionIds);
                  })
                  .then(function (bestData) {
                    input.value = '';
                    var money = Number(best.amount || 0) / 100;
                    if (String(best.code).toUpperCase() === upper) {
                      showSuccess('優惠碼「' + upper + '」已生效，折抵 $' + money.toLocaleString());
                    } else {
                      showError('優惠碼不可合併，已自動套用折扣較高的「' + String(best.code).toUpperCase() + '」');
                    }

                    var bestHtml = bestData.sections && bestData.sections[sid];
                    if (bestHtml) {
                      refreshSelfFromHtml(bestHtml);
                    } else {
                      refreshSection(sid);
                    }
                    applyPillStates(wrapper, bestData.discount_codes);

                    wrapper.__skipMonitorUntil = Date.now() + 3000;
                    notifyCartUpdate(bestData);
                    hardRefreshCartSections(sectionIds, sid);
                  });
              });
          }

          /* ✅ 套用成功 */
          input.value = '';
          var amt = Number(match.amount || 0) / 100;
          if (amt > 0) {
            showSuccess('優惠碼「' + upper + '」已生效，折抵 $' + amt.toLocaleString());
          } else {
            showSuccess('優惠碼「' + upper + '」已生效');
          }

          var newHtml = data.sections && data.sections[sid];
          if (newHtml) {
            refreshSelfFromHtml(newHtml);
          } else {
            refreshSection(sid);
          }
          applyPillStates(wrapper, data.discount_codes);

          /* 通知購物車商品列表 + 總計區塊刷新 */
          wrapper.__skipMonitorUntil = Date.now() + 3000;
          notifyCartUpdate(data);
          hardRefreshCartSections(collectCartSectionIds(sid), sid);
          return;
        }

        /* ❌ 碼完全不存在（Shopify 根本不認得） */
        showError('優惠碼目前無法使用，可能已用完、過期、未符合條件或與其他優惠衝突');
        /* 移除不存在的碼，還原成原來的碼 */
        applyDiscountCodes(existing, sectionIds);
      })
      .catch(function () {
        setLoading(false);
        showError('系統忙碌中，請稍後再試。若仍失敗，請重新整理頁面');
      });
    });

    /* ==============================================
       移除折扣碼
       ============================================== */
    wrapper.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('.cart-coupon__pill-remove');
      if (!removeBtn) return;

      var codeToRemove = removeBtn.dataset.discountCode;
      if (!codeToRemove) return;

      /* 保留其他碼 */
      var existing = getExistingCodes(wrapper);
      var remaining = existing.filter(function (c) { return c !== codeToRemove; });

      fetch(CART_UPDATE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          discount: remaining.join(','),
          sections: collectCartSectionIds(sid)
        })
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        showSuccess('已移除優惠碼「' + codeToRemove + '」');

        var newHtml = data.sections && data.sections[sid];
        if (newHtml) {
          refreshSelfFromHtml(newHtml);
        } else {
          refreshSection(sid);
        }
        applyPillStates(wrapper, data.discount_codes);

        /* 刪除時避免多重監聽鏈造成連續 5-6 次刷新 */
        var lockUntil = Date.now() + 1200;
        globalSyncLockUntil = lockUntil;
        wrapper.__skipMonitorUntil = Date.now() + 3000;
        notifyCartUpdate(data);
        setTimeout(function () {
          hardRefreshCartSections(collectCartSectionIds(sid), sid);
        }, 280);
      });
    });

    /* ==============================================
       用已有 HTML 刷新自身（省一次 request）
       ============================================== */
    function refreshSelfFromHtml(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.getElementById('CartCoupon-' + sid);
      if (!fresh) return;

      /* 暫存訊息狀態 */
      var errHidden = errorEl.classList.contains('hidden');
      var errMsg    = errorText.textContent;
      var sucHidden = successEl.classList.contains('hidden');
      var sucMsg    = successText.textContent;

      wrapper.innerHTML = fresh.innerHTML;
      wrapper.classList.add('is-open');

      /* 還原訊息 */
      var newErr     = wrapper.querySelector('.cart-coupon__error');
      var newErrText = wrapper.querySelector('.cart-coupon__error-text');
      var newSuc     = wrapper.querySelector('.cart-coupon__success');
      var newSucText = wrapper.querySelector('.cart-coupon__success-text');
      if (!errHidden && newErr && newErrText) {
        newErrText.textContent = errMsg;
        newErr.classList.remove('hidden');
      }
      if (!sucHidden && newSuc && newSucText) {
        newSucText.textContent = sucMsg;
        newSuc.classList.remove('hidden');
      }

      wrapper.__couponInit = false;
      initCoupon(wrapper);
    }

    /* ==============================================
       Fallback：Section Rendering API 刷新
       ============================================== */
    function refreshSection(sectionId) {
      fetch(ROOT + '/cart?sections=' + sectionId, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var html = json[sectionId];
        if (html) refreshSelfFromHtml(html);
      })
      .catch(function () {});
    }
  }

  /* 初始化 */
  document.querySelectorAll('[data-section-type="cart-coupon"]').forEach(initCoupon);

  /* Shopify Theme Editor */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-section-type="cart-coupon"]');
    if (el) { el.__couponInit = false; initCoupon(el); }
  });

  /* ==============================================
     購物車變更偵測 — 持續監測折扣碼適用狀態
     ============================================== */
  var monitorTimer = null;

  function debouncedMonitor() {
    clearTimeout(monitorTimer);
    monitorTimer = setTimeout(monitorDiscounts, 500);
  }

  function monitorDiscounts() {
    if (Date.now() < globalSyncLockUntil) return;
    /* 同時拉 cart.js（檢查 applicable）和 sections（更新 HTML）*/
    var wrappers = document.querySelectorAll('[data-section-type="cart-coupon"]');
    if (!wrappers.length) return;

    fetch(ROOT + '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = cart.discount_codes || [];

        wrappers.forEach(function (w) {
          if (w.__skipMonitorUntil && Date.now() < w.__skipMonitorUntil) {
            return;
          }

          var sid = w.dataset.sectionId;

          /* 刷新 section HTML（pill 金額可能有變） */
          fetch(ROOT + '/cart?sections=' + sid, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          })
          .then(function (r) { return r.json(); })
          .then(function (json) {
            var html = json[sid];
            if (!html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.getElementById('CartCoupon-' + sid);
            if (!fresh) return;

            var wasOpen = w.classList.contains('is-open');
            var oldErr = w.querySelector('.cart-coupon__error');
            var oldErrText = w.querySelector('.cart-coupon__error-text');
            var oldSuc = w.querySelector('.cart-coupon__success');
            var oldSucText = w.querySelector('.cart-coupon__success-text');
            var errHidden = oldErr ? oldErr.classList.contains('hidden') : true;
            var errMsg = oldErrText ? oldErrText.textContent : '';
            var sucHidden = oldSuc ? oldSuc.classList.contains('hidden') : true;
            var sucMsg = oldSucText ? oldSucText.textContent : '';

            w.innerHTML = fresh.innerHTML;
            if (wasOpen) w.classList.add('is-open');

            var newErr = w.querySelector('.cart-coupon__error');
            var newErrText = w.querySelector('.cart-coupon__error-text');
            var newSuc = w.querySelector('.cart-coupon__success');
            var newSucText = w.querySelector('.cart-coupon__success-text');
            if (!errHidden && newErr && newErrText) {
              newErrText.textContent = errMsg;
              newErr.classList.remove('hidden');
            }
            if (!sucHidden && newSuc && newSucText) {
              newSucText.textContent = sucMsg;
              newSuc.classList.remove('hidden');
            }

            applyPillStates(w, codes);

            w.__couponInit = false;
            initCoupon(w);
          });
        });
      })
      .catch(function () {});
  }

  /* 監聽主題原生事件 + 通用事件 */
  ['cart:update', 'discount:update',
   'cart:updated', 'cart:change', 'cart:refresh',
   'quantity:change', 'cart:item:added', 'cart:item:updated', 'cart:item:removed'
  ].forEach(function (evt) {
    document.addEventListener(evt, debouncedMonitor);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-totals"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const wrapper = document.querySelector('[data-section-type="cart-totals"]');
    if (!wrapper) return;

    // 防止重複初始化
    const FLAG = wrapper.dataset.initFlag;
    if (window[FLAG]) return;
    window[FLAG] = true;

    const sid = wrapper.dataset.sectionId;
    const contentId = wrapper.dataset.contentId;

    // 小工具：每次都取最新的 content 容器
    const getContentEl = () => document.getElementById(contentId);

    // 去抖：把頻繁的事件合併
    let tmr;
    const debounce = (fn, delay = 180) => {
      clearTimeout(tmr);
      tmr = setTimeout(fn, delay);
    };

    // 用 routes.root 支援多語系/子路徑
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

    function htmlToNode(html) {
      const dom = new DOMParser().parseFromString(html, 'text/html');
      return dom.getElementById(contentId);
    }

    function refreshTotals() {
      // 先試新版 ?sections=
      const u1 = new URL(window.location.href);
      u1.pathname = root.replace(/\/$/, '') + u1.pathname.replace(root.replace(/\/$/, ''), '');
      u1.searchParams.set('sections', sid);

      fetch(u1.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(r => r.ok ? r.json() : Promise.reject())
        .then(json => {
          const html = json && json[sid];
          if (!html) throw new Error('Sections JSON missing');
          const freshContent = htmlToNode(html);
          const contentEl = getContentEl();
          if (freshContent && contentEl) {
            contentEl.replaceWith(freshContent);
          }
        })
        .catch(() => {
          // 舊法 fallback: ?section_id=
          const u2 = new URL(window.location.href);
          u2.pathname = root.replace(/\/$/, '') + u2.pathname.replace(root.replace(/\/$/, ''), '');
          u2.searchParams.set('section_id', sid);

          fetch(u2.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(r => r.text())
            .then(html => {
              const freshContent = htmlToNode(html);
              const contentEl = getContentEl();
              if (freshContent && contentEl) {
                contentEl.replaceWith(freshContent);
              }
            })
            .catch(() => {
              console.error('Failed to refresh totals');
            });
        });
    }

    // —— A: 主題/外掛可能丟的事件 —— //
    [
      'cart:updated','cart:change','cart:refresh','quantity:change',
      'product:added','cart:item:added','cart:item:updated','cart:item:removed'
    ].forEach(evt => document.addEventListener(evt, () => debounce(() => refreshTotals(), 240)));

    // —— B: 攔截 cart 相關的 fetch / XHR —— //
    const _fetch = window.fetch;
    window.fetch = function(...args){
      return _fetch.apply(this, args).then(res => {
        try {
          const u = String(args[0]||'');
          if (u.includes('/cart') || u.includes('/add') || u.includes('cart/add')) {
            debounce(() => refreshTotals(), 260);
          }
        } catch(e){}
        return res;
      });
    };

    const _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(m, u, ...rest) {
      this.addEventListener('load', function(){
        try {
          const s = String(u||'');
          if (s.includes('/cart') || s.includes('/add') || s.includes('cart/add')) {
            debounce(() => refreshTotals(), 260);
          }
        } catch(e){}
      });
      return _open.apply(this, [m, u, ...rest]);
    };

    // —— C: 鏡像原生 summary（你是隱藏不是移除） —— //
    const nativeTotal = document.querySelector(
      '.cart-page__summary [data-cart-subtotal], .cart-page__summary .cart__total .cart__total-value'
    );
    if (nativeTotal) {
      const sync = () => {
        const mine = document.querySelector('#' + contentId + ' [data-cart-subtotal]');
        if (!mine) return;
        const t = (nativeTotal.textContent||'').trim();
        if (t && t !== (mine.textContent||'').trim()) {
          mine.textContent = t;
          mine.setAttribute('value', t);
        }
      };
      const mo = new MutationObserver(sync);
      mo.observe(nativeTotal, { characterData:true, childList:true, subtree:true });
      sync();
    }

    // 初始化先跑一次（給首次進頁或快取）
    document.addEventListener('DOMContentLoaded', () => refreshTotals());
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cinematic-video-section"] && !Shopify.designMode) return;
  try {
    
  class CinematicVideoController {
    constructor(){
      this.video = document.getElementById('brandVideo');
      this.playControl = document.getElementById('playControl');
      this.statusIndicator = document.getElementById('statusIndicator');
      this.progressBar = document.getElementById('progressBar');
      this.loadingRing = document.getElementById('loadingRing');
      this.hasPlayed = false;
      this.init();
      this.createParticles();
    }

    init(){
      this.setupIntersectionObserver();
      this.setupVideoEvents();
      this.setupPlayControl();
    }

    createParticles(){
      const canvas=document.getElementById('particleCanvas');
      const count=window.innerWidth<768?8:15;
      for(let i=0;i<count;i++){
        const p=document.createElement('div');
        p.className='floating-particle';
        p.style.left=Math.random()*100+'%';
        p.style.animationDelay=Math.random()*20+'s';
        p.style.animationDuration=(15+Math.random()*10)+'s';
        canvas.appendChild(p);
      }
    }

    setupIntersectionObserver(){
      const observer=new IntersectionObserver((entries)=>{
        entries.forEach(entry=>{
          if(entry.isIntersecting && !this.hasPlayed){
            this.autoPlay();
          }
        });
      },{threshold:.1,rootMargin:'100px 0px -50px 0px'});
      observer.observe(this.video);
    }

    setupVideoEvents(){
      this.video.addEventListener('loadeddata',()=>{this.loadingRing.classList.add('hide');});
      this.video.addEventListener('play',()=>{this.statusIndicator.classList.add('active');this.playControl.classList.remove('show');});
      this.video.addEventListener('pause',()=>{this.statusIndicator.classList.remove('active');this.playControl.classList.add('show');});
      this.video.addEventListener('ended',()=>{this.statusIndicator.classList.remove('active');this.playControl.classList.add('show');this.progressBar.style.width='0%';});
      this.video.addEventListener('timeupdate',()=>{if(this.video.duration){this.progressBar.style.width=(this.video.currentTime/this.video.duration)*100+'%';}});
      this.video.addEventListener('error',()=>{this.loadingRing.classList.add('hide');this.playControl.classList.add('show');});
    }

    setupPlayControl(){
      this.playControl.addEventListener('click',()=>{this.playVideo();});
    }

    async autoPlay(){
      try{this.video.muted=false;await this.video.play();this.hasPlayed=true;}
      catch(err){
        try{this.video.muted=true;await this.video.play();this.hasPlayed=true;}catch(e){this.playControl.classList.add('show');}
      }
    }

    async playVideo(){
      try{
        if(this.video.ended){this.video.currentTime=0;}
        this.video.muted=false;
        await this.video.play();
        this.hasPlayed=true;
      }catch(err){console.error('播放失敗',err);}
    }
  }

  document.addEventListener('DOMContentLoaded',()=>{new CinematicVideoController();});
  document.addEventListener('visibilitychange',()=>{const v=document.getElementById('brandVideo');if(document.hidden && !v.paused){v.pause();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coating-products-section"] && !Shopify.designMode) return;
  try {
    
  // 產品 ID 配置 - 只需要替換為您的實際產品 ID
    const productIds = {
      'titanium-coating': '9034349379835',  // 請替換為您實際的產品 ID
      'atomic-aurora': 'YOUR_PRODUCT_ID_2', 
      'atomic-glaze': 'YOUR_PRODUCT_ID_3',
      'atomic-microcrystal': 'YOUR_PRODUCT_ID_4',
      'atomic-sealant': 'YOUR_PRODUCT_ID_5',
      'atomic-basic': 'YOUR_PRODUCT_ID_6'
    };

    // 使用產品 ID 直接跳轉到產品頁面
    function goToProduct(productKey) {
      console.log('產品 ID:' + productKey);
      const productId = productIds[productKey];
      if (productId) {
        // 先取得產品資料來獲取正確的 handle
        fetch(`/products/${productId}.js`)
          .then(response => response.json())
          .then(product => {
            // 直接跳轉到產品頁面
            window.location.href = `/products/${product.handle}`;
          })
          .catch(error => {
            console.error('跳轉失敗:', error);
            // 備用方案：使用產品 ID 進行搜尋
            window.location.href = `/search?q=id:${productId}`;
          });
      } else {
        console.error('找不到產品 ID:', productKey);
      }
    }

    // 滾動指示器邏輯
    document.addEventListener('DOMContentLoaded', function() {
      const scroller = document.getElementById('productScroller');
      const dots = document.querySelectorAll('.scroll-dot');
      
      if (scroller && dots.length > 0) {
        // 更新滾動指示器
        function updateScrollIndicator() {
          const scrollLeft = scroller.scrollLeft;
          const scrollWidth = scroller.scrollWidth - scroller.clientWidth;
          const scrollPercentage = scrollLeft / scrollWidth;
          
          // 根據滾動位置計算當前應該高亮的點
          const activeIndex = Math.round(scrollPercentage * (dots.length - 1));
          
          dots.forEach((dot, index) => {
            if (index === activeIndex) {
              dot.classList.add('active');
            } else {
              dot.classList.remove('active');
            }
          });
        }
        
        // 監聽滾動事件
        scroller.addEventListener('scroll', updateScrollIndicator);
        
        // 初始化
        updateScrollIndicator();
      }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-hero-section"] && !Shopify.designMode) return;
  try {
    
function handleConsultClick(){
  console.log('開啟專員諮詢服務');
  alert('即將為您開啟專員諮詢服務！');
}
function handleStoreClick(){
  console.log('開啟店鋪查詢功能');
  alert('即將為您開啟店鋪查詢功能！');
}
document.addEventListener('DOMContentLoaded',function(){
  const titleElements=document.querySelectorAll('.fade-in-up');
  titleElements.forEach((el,i)=>{setTimeout(()=>{el.classList.add('animate');},200+i*150);});
  const assistanceCards=document.querySelectorAll('.fade-in-left');
  assistanceCards.forEach((card,i)=>{setTimeout(()=>{card.classList.add('animate');},600+i*200);});
});
function switchToImageTitle(imagePath){
  const title=document.querySelector('.page-title');
  title.classList.add('image-title');
  title.style.backgroundImage=`url('${imagePath}')`;
  if(!document.querySelector('.sr-only')){
    const srText=document.createElement('span');
    srText.className='sr-only';
    srText.textContent=title.textContent+' - APGO專業汽車鍍膜';
    title.parentNode.appendChild(srText);
  }
}
window.addEventListener('resize',function(){});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparison-section"] && !Shopify.designMode) return;
  try {
    
  // 進度條進場動畫
  document.addEventListener('DOMContentLoaded',function(){
    const bars=document.querySelectorAll('.bar-fill');
    const observer=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        if(entry.isIntersecting){
          bars.forEach((bar,i)=>{
            const width=bar.style.width;
            bar.style.width='0';
            setTimeout(()=>{bar.style.width=width;},100+i*100);
          });
          observer.disconnect();
        }
      });
    });
    const section=document.querySelector('.comparison-section');
    if(section)observer.observe(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-section"] && !Shopify.designMode) return;
  try {
    
  // JS 行為：滾動指示器、視差效果、鍵盤支援
  document.addEventListener('DOMContentLoaded', function () {
    const indicator = document.querySelector('.scroll-indicator');
    if (indicator) {
      indicator.addEventListener('click', function () {
        window.scrollTo({ top: window.innerHeight, behavior: 'smooth' });
      });
    }

    window.addEventListener('scroll', function () {
      const scrolled = window.pageYOffset;
      const heroImage = document.querySelector('.hero-image');
      const scrollIndicator = document.querySelector('.scroll-indicator');
      const parallaxSpeed = 0.5;
      if (heroImage && scrolled < window.innerHeight) {
        heroImage.style.transform = `scale(1.05) translateY(${scrolled * parallaxSpeed}px)`;
      }
      if (scrollIndicator) {
        if (scrolled > 100) {
          scrollIndicator.classList.add('hide');
        } else {
          scrollIndicator.classList.remove('hide');
        }
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === ' ') {
        e.preventDefault();
        window.scrollTo({ top: window.innerHeight, behavior: 'smooth' });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["livestream-stats-section"] && !Shopify.designMode) return;
  try {
    
  // 創建愛心的函數
  function createHeart(container) {
    const heart = document.createElement('div');
    const colors = ['heart-red', 'heart-pink', 'heart-orange', 'heart-yellow', 'heart-purple'];
    const paths = ['heart-path-1', 'heart-path-2', 'heart-path-3', 'heart-path-4'];
    const randomColor = colors[Math.floor(Math.random() * colors.length)];
    const randomPath = paths[Math.floor(Math.random() * paths.length)];

    heart.className = `heart ${randomColor} ${randomPath}`;

    // 固定在右側，稍微有一點隨機偏移
    const randomOffset = Math.random() * 10 - 5; // -5 到 +5 的偏移
    heart.style.right = 30 + randomOffset + 'px';

    // 隨機大小
    const randomScale = 0.85 + Math.random() * 0.3;
    heart.style.transform = `rotate(-45deg) scale(${randomScale})`;

    // 隨機動畫時長（增加變化）
    const randomDuration = 4 + Math.random() * 2;
    heart.style.animationDuration = randomDuration + 's';

    container.appendChild(heart);

    // 動畫結束後移除
    setTimeout(() => {
      heart.remove();
    }, randomDuration * 1000);
  }

  // 持續生成愛心
  function startHeartAnimation() {
    const activeWrapper = document.querySelector('.team-image-wrapper.active');
    if (activeWrapper) {
      const heartsContainer = activeWrapper.querySelector('.hearts-container');
      if (heartsContainer) {
        createHeart(heartsContainer);
      }
    }
  }

  // 每隔一段時間生成愛心
  let heartInterval = setInterval(startHeartAnimation, 800);

  // 分頁切換功能
  function initTabSwitching() {
    const tabButtons = document.querySelectorAll('.tab-button');
    const teamImages = document.querySelectorAll('.team-image-wrapper');
    const taiwanVideo = document.querySelector('#taiwan-team .team-video');
    const sgMyVideo = document.querySelector('#sg-my-team .team-video');

    // 手動切換功能
    tabButtons.forEach((button) => {
      button.addEventListener('click', function () {
        // 移除所有 active 類
        tabButtons.forEach((btn) => btn.classList.remove('active'));
        teamImages.forEach((img) => img.classList.remove('active'));

        // 添加 active 類到點擊的按鈕
        this.classList.add('active');

        // 顯示對應的圖片
        const teamType = this.dataset.team;
        const targetImage = document.getElementById(`${teamType}-team`);
        if (targetImage) {
          targetImage.classList.add('active');
        }

        // 暫停非活動影片，播放活動影片
        if (teamType === 'taiwan') {
          taiwanVideo.play();
          sgMyVideo.pause();
          sgMyVideo.currentTime = 0;
        } else {
          sgMyVideo.play();
          taiwanVideo.pause();
          taiwanVideo.currentTime = 0;
        }
      });
    });

    // 自動切換功能 - 當台灣影片播放結束時
    if (taiwanVideo) {
      taiwanVideo.addEventListener('ended', function () {
        // 切換到新馬團隊
        const sgMyButton = document.querySelector('[data-team="sg-my"]');
        const taiwanButton = document.querySelector('[data-team="taiwan"]');

        // 更新按鈕狀態
        taiwanButton.classList.remove('active');
        sgMyButton.classList.add('active');

        // 切換影片
        document.getElementById('taiwan-team').classList.remove('active');
        document.getElementById('sg-my-team').classList.add('active');

        // 播放新馬影片
        sgMyVideo.currentTime = 0;
        sgMyVideo.play();
      });
    }

    // 當新馬影片播放結束時，切回台灣影片
    if (sgMyVideo) {
      sgMyVideo.addEventListener('ended', function () {
        // 切換回台灣團隊
        const sgMyButton = document.querySelector('[data-team="sg-my"]');
        const taiwanButton = document.querySelector('[data-team="taiwan"]');

        // 更新按鈕狀態
        sgMyButton.classList.remove('active');
        taiwanButton.classList.add('active');

        // 切換影片
        document.getElementById('sg-my-team').classList.remove('active');
        document.getElementById('taiwan-team').classList.add('active');

        // 播放台灣影片
        taiwanVideo.currentTime = 0;
        taiwanVideo.play();
      });
    }
  }

  // 數字跳動動畫
  function animateNumbers() {
    const numbers = document.querySelectorAll('.stat-number');

    numbers.forEach((number, index) => {
      const target = parseInt(number.getAttribute('data-target'));
      const duration = 2000;
      const increment = target / (duration / 16);
      let current = 0;

      // 延遲啟動，創造依序動畫效果
      setTimeout(() => {
        const updateNumber = () => {
          current += increment;
          if (current < target) {
            number.textContent = formatNumber(Math.floor(current));
            number.classList.add('counting');
            setTimeout(() => number.classList.remove('counting'), 100);
            requestAnimationFrame(updateNumber);
          } else {
            number.textContent = formatNumber(target);
          }
        };
        updateNumber();
      }, index * 200);
    });
  }

  // 格式化數字（添加千分位）
  function formatNumber(num) {
    if (num >= 1000000) {
      return Math.floor(num / 10000) + '萬';
    } else if (num >= 10000) {
      return (num / 10000).toFixed(0) + '萬';
    }
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // Intersection Observer 監聽元素進入視窗
  const observerOptions = {
    threshold: 0.3,
    rootMargin: '0px',
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        animateNumbers();
        observer.disconnect();
      }
    });
  }, observerOptions);

  // 開始觀察
  document.addEventListener('DOMContentLoaded', () => {
    initTabSwitching();

    const section = document.querySelector('.stats-showcase');
    if (section) {
      observer.observe(section);
    }
  });

  // CTA按鈕波紋效果
  document.querySelector('.cta-button').addEventListener('click', function (e) {
    const ripple = document.createElement('span');
    const rect = this.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = e.clientX - rect.left - size / 2;
    const y = e.clientY - rect.top - size / 2;

    ripple.style.cssText = `
                position: absolute;
                width: ${size}px;
                height: ${size}px;
                border-radius: 50%;
                background: rgba(255, 255, 255, 0.5);
                left: ${x}px;
                top: ${y}px;
                pointer-events: none;
                transform: scale(0);
                animation: rippleEffect 0.6s ease-out;
            `;

    this.appendChild(ripple);
    setTimeout(() => ripple.remove(), 600);
  });

  // 添加波紋動畫樣式
  const style = document.createElement('style');
  style.textContent = `
            @keyframes rippleEffect {
                to {
                    transform: scale(4);
                    opacity: 0;
                }
            }
        `;
  document.head.appendChild(style);

  // 清理定時器（當頁面關閉時）
  window.addEventListener('beforeunload', () => {
    clearInterval(heartInterval);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
